// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3d76d778","453":"4a1a2f07","732":"0ce67114"}[chunkId] + ".chunk.js";
};